import { isTouchable, useDidFinishSSR, useMedia } from "tamagui";

// True when the adaptive Dropdown shows its sheet, not the popover. Gate
// sheet-vs-popover behavior on this, never `useMedia().sm` alone (a narrow
// non-touch desktop window stays a popover). `useDidFinishSSR()` defers the
// `isTouchable` read until hydration so the server and first client paint agree
// (popover), avoiding a touch-viewport hydration flash.
export const useInSheet = (): boolean => {
  const hydrated = useDidFinishSSR();
  return useMedia().sm && hydrated && isTouchable;
};
